import { render, staticRenderFns } from "./CodeContentMenuItems.vue?vue&type=template&id=50f62647&scoped=true&"
import script from "./CodeContentMenuItems.vue?vue&type=script&lang=ts&"
export * from "./CodeContentMenuItems.vue?vue&type=script&lang=ts&"
import style0 from "./CodeContentMenuItems.vue?vue&type=style&index=0&id=50f62647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f62647",
  null
  
)

export default component.exports